"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = percentageLabel;

var _argumentContracts = _interopRequireDefault(require("argument-contracts"));

var _percentageLabelFormatter = _interopRequireDefault(require("../../percentage-label-formatter"));

/**
 * percentageLabel
 * @param {AxisLabelFormatterOptions} options A valid AxisLabelFormatterOptions object
 * @returns {string} A properly formatted string
 */
function percentageLabel(options) {
  _argumentContracts.default.assertNumber(options.value, 'options.value');

  return (0, _percentageLabelFormatter.default)(options.value);
}